<template>
  <div class="main">
    <div class="login-container">
      <div class="login-header">
        <span>comori</span> 管理画面
      </div>
      <div class="login-body">
        <p>ログイン</p>
        <div class="login-form">
          <b-form @submit.prevent="login">
            <b-form-group
              id="admin-id"
              label="ID"
              label-for="id">
              <b-form-input
                id="id"
                v-model="form.email"
                type="text"
                required
                placeholder="Admin ID"></b-form-input>
            </b-form-group>
            <b-form-group
              id="admin-password"
              label="パスワード"
              label-for="password">
              <b-form-input
                id="password"
                v-model="form.password"
                type="password"
                required
                placeholder="パスワード"></b-form-input>
            </b-form-group>
            <p class="login-button">
              <b-button type="submit" variant="primary">ログイン</b-button>
            </p>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import apiClient from '../../backend'

export default {
  methods: {
  },
  data () {
    return {
      form: {
        email: '',
        passowrd: '',
        role: 3
      }
    }
  },
  components: {
  },
  mounted () {
  },
  methods: {
    login() {
      apiClient.login(this.form).then(response => {
        console.log(response)
        this.$store.dispatch('setAuthResult', response)
        this.$router.push({name: 'user_list'})
      })
    }
  },
  validations: {
  }
}
</script>
